import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subject, filter, map, startWith, takeUntil } from 'rxjs';
import { PdfViewerService } from '../../pdf-viewer.service';
import { PdfDocumentViewportsContainerService } from '../pdf-document-viewports-container/pdf-document-viewports-container.service';
import { PdfPageService } from './pdf-page.service';

@Component({
  selector: 'ss-pdf-page',
  templateUrl: './pdf-page.component.html',
  styleUrls: ['./pdf-page.component.css'],
  providers: [
    PdfPageService
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfPageComponent implements OnInit {
  private readonly _destroy = new Subject<void>()

  @ViewChildren('pdfPageCanvas', { read: ElementRef })
  private _pdfPageCanvasQL!: QueryList<ElementRef<HTMLCanvasElement>>

  @ViewChildren('divOverlay', { read: ElementRef })
  private _divOverlayQL!: QueryList<ElementRef<HTMLCanvasElement>>

  readonly pageInfoSubject = this._pdfPageService.pageInfoSubject;
  @Input() get pageInfo() {
    return this.pageInfoSubject.value
  }
  set pageInfo(value) {
    this.pageInfoSubject.next(value)
  }

  readonly PAGE_SPACING = this._pdfViewerService.PAGE_SPACING;

  readonly heightObs = this.pageInfoSubject.pipe(filter(Boolean), map((pageInfo => pageInfo.dimensions.height)))
  readonly widthObs = this.pageInfoSubject.pipe(filter(Boolean), map((pageInfo => pageInfo.dimensions.width)))

  readonly styleObs = this.pageInfoSubject.pipe(filter(Boolean),
    map((pageInfo => ({
      height: pageInfo.dimensions.height + 'px',
      width: pageInfo.dimensions.width + 'px',
    })))
  );

  readonly addedPageContentSubject = this._pdfViewerService.addedPageContentSubject;
  readonly selectedZoomSubject = this._pdfDocumentViewportsContainerService.selectedZoomSubject;
  readonly renderingSubject = this._pdfPageService.renderingSubject;
  readonly renderedSubject = this._pdfPageService.renderedSubject;
  readonly pdfPageVisibleSubject = this._pdfPageService.pdfPageVisibleSubject

  readonly pageOverlayStyleSubject = this._pdfDocumentViewportsContainerService.pageOverlayStyleSubject;

  readonly imgPathObs = this._pdfPageService.imgPathObs;

  readonly showLoadingObs = this.imgPathObs.pipe(map((img) => !img))

  constructor(
    private _pdfDocumentViewportsContainerService: PdfDocumentViewportsContainerService,
    private _pdfPageService: PdfPageService,
    private _pdfViewerService: PdfViewerService
  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {


    this._divOverlayQL.changes.pipe(
      startWith(this._divOverlayQL),
      filter(Boolean),
      map((ql: QueryList<ElementRef<HTMLDivElement>>) => ql.first?.nativeElement),
      takeUntil(this._destroy)
    )
      .subscribe(divOverlay => {
        this._pdfPageService.divOverlaySubject.next(divOverlay);
      })


    this._pdfPageCanvasQL.changes.pipe(
      startWith(this._pdfPageCanvasQL),
      filter(Boolean),

      map((ql: QueryList<ElementRef<HTMLCanvasElement>>) => ql.first?.nativeElement),
      takeUntil(this._destroy)
    )
      .subscribe(canvasElement => {
        this._pdfPageService.canvasElementSubject.next(canvasElement);
      })


    // this.pdfDocumentsSubject.subscribe(() => {
    //   this.renderPage();
    // })

  }

  async renderPage() {

    // await this._pdfPageService.renderPage();
  }

  ngOnDestroy() {
    this._destroy.next()
    this._destroy.complete()
  }

}

